import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import type { StatusLabels } from '@plugins/faq-lib/types';

@Component({
  selector: 'faq-status-icon',
  standalone: false,
  templateUrl: './status-icon.component.html',
  styleUrl: './status-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusIconComponent {
  readonly status = input.required<StatusLabels>();
}
